import { render, staticRenderFns } from "./sfjgcx.vue?vue&type=template&id=c5338cac&scoped=true"
import script from "./sfjgcx.vue?vue&type=script&lang=js"
export * from "./sfjgcx.vue?vue&type=script&lang=js"
import style0 from "./sfjgcx.vue?vue&type=style&index=0&id=c5338cac&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5338cac",
  null
  
)

export default component.exports